var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blackover-active",attrs:{"id":"overscreen"}})
}
var staticRenderFns = []

export { render, staticRenderFns }